import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { getRequest, postRequest } from 'utils/http'

export const useGetConflicts = (page = 1, perPage = 20) => {
  return useQuery({
    queryKey: ['reconciliation-conflicts', page, perPage],
    queryFn: async () => {
      const response = await getRequest('reconciliation/conflicts', {
        params: {
          page,
          per_page: perPage,
        },
      })
      return response
    },
    keepPreviousData: true,
  })
}

export const useResolveConflict = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ orderId, action, notes }) => {
      return await postRequest(`reconciliation/orders/${orderId}/resolve`, {
        action,
        notes,
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['reconciliation-conflicts'] })
      queryClient.invalidateQueries({ queryKey: ['audit-logs'] })
      queryClient.invalidateQueries({ queryKey: ['tickets'] })
    },
  })
}

export const useRunReconciliation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async () => {
      return await postRequest('reconciliation/run')
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['reconciliation-conflicts'] })
      queryClient.invalidateQueries({ queryKey: ['audit-logs'] })
    },
  })
}

export const useGetAuditLogs = (page = 1, perPage = 25, action = '') => {
  return useQuery({
    queryKey: ['audit-logs', page, perPage, action],
    queryFn: async () => {
      const response = await getRequest('audit-logs', {
        params: {
          page,
          per_page: perPage,
          action: action || undefined,
        },
      })
      return response
    },
    keepPreviousData: true,
  })
}
